(function () {
  var root = document.querySelector('[data-tp-sample-checkout]');
  if (!root) return;

  var core = window.TPSampleCheckoutCore;
  var HANDLE_PATTERN = /^[a-z0-9-]+$/;

  var loadingEl = root.querySelector('[data-sample-loading]');
  var errorEl = root.querySelector('[data-sample-error]');
  var fieldsetEl = root.querySelector('[data-sample-fieldset]');
  var gridEl = root.querySelector('[data-sample-grid]');
  var countEl = root.querySelector('[data-sample-count]');
  var submitEl = root.querySelector('[data-sample-submit]');
  var cartLinkEl = root.querySelector('[data-sample-cart-link]');
  var productWrapEl = root.querySelector('[data-sample-product]');
  var productImageEl = root.querySelector('[data-sample-product-image]');
  var productNameEl = root.querySelector('[data-sample-product-name]');

  var selected = new Set();
  var sampleVariantId = null;
  var product = null;
  var colors = [];
  var optionName = 'Farbe';
  var existingKeys = new Set();
  var cartSampleCount = 0;
  // Alle Muster im Warenkorb (fuer den Warenkorb-Link) - cartSampleCount ist
  // bei Vinyl nur die Zahl der Vinyl-Muster, wenn die Vinyl-Grenze bindet.
  var cartTotalCount = 0;
  var remaining = window.TPSampleCheckoutCore ? window.TPSampleCheckoutCore.MAX_SAMPLES : 3;
  // Grenze fuer das geladene Produkt (core.getLimit): Gesamtgrenze oder bei
  // Vinyl die engere Vinyl-Grenze.
  var limitMax = remaining;
  var limitWord = 'Muster';
  var submitting = false;

  function showError(message) {
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function musterAufAnfrage(p) {
    var typ = String((p && p.type) || '').trim().toLowerCase();
    if (['laminat', 'parkett', 'kork'].indexOf(typ) === -1) return false;
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
    return !tags.some(function (tag) {
      var name = String(tag || '').trim().toLowerCase();
      return name === 'zubehoer' || name === 'ohne-muster';
    });
  }

  function hideError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function getParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name) || '';
  }

  function fetchJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('request-failed');
      return response.json();
    });
  }

  // Uebernimmt den Warenkorbstand: schon bestellte Farben, Anzahl und die
  // fuer dieses Produkt bindende Grenze.
  function applyCart(cart) {
    var state = core.getSampleState(cart);
    var limit = core.getLimit(product, state);
    existingKeys = state.keys;
    cartSampleCount = limit.inCart;
    cartTotalCount = state.count;
    remaining = limit.remaining;
    limitMax = limit.max;
    limitWord = limit.word;
  }

  // Vinyl: Hinweis auf die Grenze von 2 je Bestellung.
  function showVinylLimit() {
    if (!core.isVinyl(product)) return;
    root.querySelectorAll('[data-sample-max]').forEach(function (el) {
      el.textContent = String(core.VINYL_MAX);
    });
    var vinylEl = root.querySelector('[data-sample-vinyl]');
    if (vinylEl) vinylEl.hidden = false;
  }

  // JAB und Vorwerk: Muster kommt direkt vom Hersteller (statt "ca. A5").
  function showHerstellerHinweis() {
    if (!core.isHerstellerMuster(product)) return;
    var infoEl = root.querySelector('[data-sample-info]');
    var herstellerEl = root.querySelector('[data-sample-hersteller]');
    if (!herstellerEl) return;
    if (infoEl) infoEl.hidden = true;
    herstellerEl.hidden = false;
  }

  function updateCount() {
    var status = core.getSelectionStatus(cartSampleCount, selected.size, limitMax, limitWord);
    countEl.textContent = status.message;
    countEl.classList.toggle('tp-sample__count--limit', status.limitReached);
    submitEl.disabled = submitting || selected.size === 0;
    cartLinkEl.hidden = cartTotalCount === 0;

    gridEl.querySelectorAll('[data-sample-color]').forEach(function (card) {
      var value = card.getAttribute('data-sample-color');
      var checkbox = card.querySelector('input[type="checkbox"]');
      var alreadyInCart = existingKeys.has(makeCardKey({ value: value }));
      var blockedByLimit = status.limitReached && !selected.has(value);
      // Gesperrtes Muster (Mustervariante nicht verfuegbar): immer deaktiviert.
      var unavailable = card.getAttribute('data-sample-unavailable') !== null;
      checkbox.disabled = unavailable || alreadyInCart || blockedByLimit;
      if (checkbox.disabled) {
        card.setAttribute('aria-disabled', 'true');
      } else {
        card.removeAttribute('aria-disabled');
      }
    });
  }

  function makeCardKey(color) {
    return core.sampleKey(product.handle, color.value);
  }

  function toggleCard(card, color) {
    var key = makeCardKey(color);
    var isSelected = selected.has(color.value);
    var checkbox = card.querySelector('input[type="checkbox"]');

    if (!core.isSelectable(color)) {
      checkbox.checked = false;
      return;
    }

    if (isSelected) {
      selected.delete(color.value);
      card.setAttribute('data-selected', 'false');
      checkbox.checked = false;
      updateCount();
      return;
    }

    if (existingKeys.has(key)) {
      checkbox.checked = false;
      return;
    }
    if (selected.size >= remaining) {
      checkbox.checked = false;
      return;
    }

    selected.add(color.value);
    card.setAttribute('data-selected', 'true');
    checkbox.checked = true;
    updateCount();
  }

  function renderColors() {
    gridEl.textContent = '';

    colors.forEach(function (color) {
      var key = makeCardKey(color);
      // Gesperrte Farbe bleibt sichtbar, damit der Kunde sieht, dass es sie
      // gibt - nur das Muster ist derzeit nicht lieferbar.
      var unavailable = !core.isSelectable(color);
      var disabled = unavailable || existingKeys.has(key);

      var card = document.createElement('label');
      card.className = 'tp-sample__card';
      card.setAttribute('data-sample-color', color.value);
      card.setAttribute('data-selected', 'false');
      if (unavailable) card.setAttribute('data-sample-unavailable', '');
      if (disabled) card.setAttribute('aria-disabled', 'true');

      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.className = 'tp-sample__card-input';
      checkbox.disabled = disabled;
      checkbox.addEventListener('change', function () {
        toggleCard(card, color);
      });

      var image = document.createElement('img');
      image.loading = 'lazy';
      image.alt = '';
      image.src = color.image || '';

      var label = document.createElement('span');
      label.className = 'tp-sample__card-label';
      label.textContent = color.value;

      var check = document.createElement('span');
      check.className = 'tp-sample__card-check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';

      card.appendChild(checkbox);
      card.appendChild(image);
      card.appendChild(label);
      if (unavailable) {
        var status = document.createElement('span');
        status.className = 'tp-sample__card-status';
        status.textContent = 'Kein Muster verfügbar';
        card.appendChild(status);
      }
      card.appendChild(check);
      gridEl.appendChild(card);
    });

    updateCount();
  }

  // Die Produktseite haengt die dort gewaehlte Farbe als ?farbe= an
  // (assets/tp-farbauswahl.js). Vorauswahl ueber denselben Weg wie ein Tipp
  // des Kunden, damit Limit und bereits bestellte Muster weiter gelten.
  // Unbekannter Wert: nichts passiert. Ohne Wert wird nur gewaehlt, wenn es
  // genau ein Dekor gibt (Einzeldekor wie Klickvinyl) - sonst muesste der
  // Kunde das einzige Kaestchen selbst antippen (Fehleranalyse 13.10.).
  function vorauswahl(farbe) {
    var cards = gridEl.querySelectorAll('[data-sample-color]');
    if (!farbe) {
      if (cards.length !== 1) return;
      var einzige = cards[0].querySelector('input[type="checkbox"]');
      if (einzige && !einzige.disabled && !einzige.checked) einzige.click();
      return;
    }
    for (var i = 0; i < cards.length; i += 1) {
      if (cards[i].getAttribute('data-sample-color') !== farbe) continue;
      var checkbox = cards[i].querySelector('input[type="checkbox"]');
      if (checkbox && !checkbox.disabled && !checkbox.checked) checkbox.click();
      cards[i].scrollIntoView({ block: 'center' });
      return;
    }
  }

  function submitSelection() {
    if (submitting || selected.size === 0 || !core.canSample(product)) return;
    submitting = true;
    submitEl.disabled = true;
    hideError();

    // Warenkorb unmittelbar vor dem Hinzufuegen neu lesen: In einem zweiten
    // Tab koennen inzwischen Muster dazugekommen sein. Passt die Auswahl
    // nicht mehr unter die Grenze, wird nichts hinzugefuegt, sondern die
    // Auswahl mit dem neuen Stand angezeigt.
    fetchJson('/cart.js').catch(function () { return null; }).then(function (cart) {
      if (cart) {
        applyCart(cart);
        var doppelt = false;
        selected.forEach(function (value) {
          if (existingKeys.has(makeCardKey({ value: value }))) doppelt = true;
        });
        var ueber = selected.size > remaining;
        if (doppelt || ueber) {
          selected.clear();
          submitting = false;
          renderColors();
          showError(ueber
            ? 'Im Warenkorb liegen inzwischen weitere Muster. Je Bestellung sind höchstens ' + limitMax + ' ' + limitWord + ' möglich – bitte wählen Sie erneut.'
            : 'Ein ausgewähltes Muster liegt inzwischen schon im Warenkorb. Bitte prüfen Sie Ihre Auswahl.');
          return;
        }
      }
      addSelection();
    });
  }

  function addSelection() {
    var chosenColors = colors.filter(function (color) {
      return selected.has(color.value) && core.isSelectable(color);
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: core.buildCartItems({
          product: product,
          colors: chosenColors,
          optionName: optionName,
          sampleVariantId: sampleVariantId,
          origin: window.location.origin,
        }),
      }),
    }).then(function (response) {
      if (!response.ok) throw new Error('add-failed');
      cartLinkEl.hidden = false;
      window.location.href = window.TP_SAMPLE_CART_URL || '/cart';
    }).catch(function () {
      submitting = false;
      updateCount();
      showError('Das Hinzufügen hat nicht funktioniert. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.');
    });
  }

  function init() {
    var handle = getParam('produkt');
    if (!handle || !HANDLE_PATTERN.test(handle)) {
      // Ohne Produkt kommt der Kunde aus Top-Leiste, Chips oder SEO-Links:
      // Weg erklaeren statt Fehlermeldung und ausgegrautem Button.
      loadingEl.hidden = true;
      var emptyEl = root.querySelector('[data-sample-empty]');
      var introEl = root.querySelector('[data-sample-intro]');
      if (emptyEl) {
        emptyEl.hidden = false;
        submitEl.hidden = true;
        if (introEl) introEl.hidden = true;
        return;
      }
      showError('Für dieses Produkt sind aktuell keine Muster hinterlegt.');
      return;
    }

    // Musterprodukt der Qualitaet zuerst (eigene Variante je Farbe). Fehlt es
    // bei einem Teppich nach Mass, das Musterprodukt des Teppichbodens
    // (ladeBasisMuster). Das Sammelprodukt "Kostenloses Muster" bleibt der
    // Rueckfall fuer alles, was keine eigene Mustervariante findet.
    function fetchOptional(url) {
      return fetchJson(url).catch(function () { return null; });
    }

    // sections/tp-muster-basis nennt im Kontext des Produkts, welche
    // Musterprodukte es gibt: muster-<handle> und - fuer Teppiche nach Mass -
    // das Musterprodukt des Teppichbodens (service.einfass_basis). Abgerufen
    // wird nur, was dort steht; ein blinder Abruf von muster-<handle> erzeugte
    // bei jedem Produkt ohne eigenes Muster einen 404 in der Konsole
    // (Fehleranalyse 13.10.). Scheitert die Section, bleibt es beim Sammelprodukt.
    function ladeSection() {
      return fetch(core.basisSectionUrl(handle), { headers: { Accept: 'text/html' } })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .catch(function () { return ''; });
    }

    // Ergebnis: [eigenes Musterprodukt, Musterprodukt des Teppichbodens].
    // Das Basis-Muster zaehlt nur, wenn es kein eigenes gibt.
    function ladeMuster(html) {
      var quelle = core.parseMusterQuelle(html);
      if (quelle) {
        var eigen = quelle.eigen ? fetchOptional('/products/' + quelle.eigen + '.js') : Promise.resolve(null);
        return eigen.then(function (musterProdukt) {
          if (musterProdukt || !quelle.basis) return [musterProdukt, null];
          return fetchOptional('/products/' + quelle.basis + '.js').then(function (basisMuster) {
            return [null, basisMuster];
          });
        });
      }
      // Section ohne Angabe (z. B. aelterer Theme-Stand im Cache): wie bisher
      // erst muster-<handle> probieren, dann den Basis-Handle.
      return fetchOptional('/products/' + core.sampleProductHandle(handle) + '.js').then(function (musterProdukt) {
        if (musterProdukt) return [musterProdukt, null];
        var basis = core.parseBasisHandle(html, handle);
        if (!basis) return [null, null];
        return fetchOptional('/products/' + core.sampleProductHandle(basis) + '.js').then(function (basisMuster) {
          return [null, basisMuster];
        });
      });
    }

    Promise.all([
      fetchJson('/products/' + handle + '.js'),
      fetchJson('/products/kostenloses-muster.js'),
      fetchJson('/cart.js'),
      ladeSection(),
    ]).then(function (results) {
      product = results[0];
      if (!core.canSample(product)) {
        loadingEl.hidden = true;
        // Kein Muster ueber diese Seite: die Zeile "Muster ca. A5 ..." passt
        // dann nicht zum Hinweis darunter (Laminat, Parkett, Kork, ohne Muster).
        var infoEl = root.querySelector('[data-sample-info]');
        if (infoEl) infoEl.hidden = true;
        if (musterAufAnfrage(product)) {
          // Laminat, Parkett, Kork: kostenlos, aber nur auf Anfrage
          // (Inhaber 14.10.2026, blocks/tp-muster-cta). Alte Links landen hier.
          showError('Muster für ' + product.title + ' sind kostenlos wie alle unsere Muster. Weil sie wertiger sind, senden wir sie nach kurzer Anfrage zu.');
          var anfrage = document.createElement('a');
          anfrage.href = '/pages/kontakt?thema=musteranfrage&produkt=' + encodeURIComponent(product.title) + '&handle=' + encodeURIComponent(product.handle);
          anfrage.textContent = 'Kostenloses Muster anfragen';
          errorEl.appendChild(document.createTextNode(' '));
          errorEl.appendChild(anfrage);
          return;
        }
        showError('Für dieses Produkt bieten wir derzeit keine kostenlosen Muster an. Bitte kontaktieren Sie uns für eine persönliche Beratung.');
        return;
      }
      var sampleProduct = results[1];
      var cart = results[2];
      var sectionHtml = results[3];

      var sampleVariant = (sampleProduct.variants || []).find(function (variant) {
        return variant.available;
      });
      if (!sampleVariant) throw new Error('no-sample-variant');
      sampleVariantId = sampleVariant.id;

      colors = core.getUniqueColors(product);
      if (colors.length === 0) throw new Error('no-colors');

      // Beschriftungen an das Sortiment anpassen: "Farben" oder "Dekore".
      optionName = core.getOptionName(product);
      return ladeMuster(sectionHtml).then(function (muster) {
        colors = core.applySperrliste(core.assignSampleVariantsWithBasis(colors, muster[0], muster[1], optionName), product.handle);
        root.querySelectorAll('[data-sample-term]').forEach(function (el) {
          el.textContent = core.getOptionTerm(product, el.getAttribute('data-sample-term'));
        });

        applyCart(cart);
        showVinylLimit();
        showHerstellerHinweis();

        productImageEl.src = product.featured_image || '';
        productNameEl.textContent = product.title;
        var klebeEl = root.querySelector('[data-sample-klebe]');
        if (klebeEl) klebeEl.hidden = (product.tags || []).indexOf('muster-klebevariante') === -1;
        productWrapEl.hidden = false;

        loadingEl.hidden = true;
        // Alle Farben gesperrt: Hinweis statt Karten, kein Bestellknopf.
        if (core.allSamplesUnavailable(colors)) {
          var noneEl = root.querySelector('[data-sample-none]');
          var introEl = root.querySelector('[data-sample-intro]');
          if (introEl) introEl.hidden = true;
          submitEl.hidden = true;
          cartLinkEl.hidden = cartTotalCount === 0;
          if (noneEl) {
            noneEl.hidden = false;
          } else {
            showError('Für dieses Produkt sind derzeit keine Muster verfügbar.');
          }
          return;
        }
        fieldsetEl.hidden = false;
        renderColors();
        vorauswahl(getParam('farbe'));
      });
    }).catch(function () {
      loadingEl.hidden = true;
      showError('Für dieses Produkt sind aktuell keine Muster hinterlegt.');
    });
  }

  submitEl.addEventListener('click', submitSelection);
  // Zurueck-Knopf aus dem Warenkorb: Seiten aus dem Browser-Cache tragen den
  // alten Warenkorbstand - neu laden, damit Grenze und Auswahl stimmen.
  if (window.addEventListener) {
    window.addEventListener('pageshow', function (event) {
      if (event && event.persisted) window.location.reload();
    });
  }
  init();
})();
